import { darken, lighten, createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';

const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#1E396A',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#da5b3e',
      contrastText: '#ffffff',
    },
    navigation: {
      dark: darken('#dddddd', 0.15),
      light: lighten('#dddddd', 0.15),
      main: '#dddddd',
      contrastText: '#ffffff',
    },
    error: {
      dark: darken(red.A400, 0.15),
      light: lighten(red.A400, 0.15),
      main: red.A400,
      contrastText: '#ffffff',
    },
    success: {
      dark: darken(green[500], 0.15),
      light: lighten(green[500], 0.15),
      main: green[500],
      contrastText: '#ffffff',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  overrides: {
    MuiListItemIcon: {
      root: {
        color: 'inherit',
        minWidth: 32,
      },
    },
    MuiTableRow: {
      root: {
        '&:nth-of-type(odd)': {
          background: 'rgba(0,0,0,.05)',
        },
      },
      head: {
        '&:nth-of-type(odd)': {
          background: 'initial',
        },
      },
    },
    MuiTableCell: {
      root: {
        border: '1px solid rgba(224, 224, 224, 1)',
        padding: '8px 16px',
      },
    },
  },
});

export default theme;
